export default __webpack_public_path__ + "static/media/pantry2-before2-768w.8a63211a.avif";